import React, { Component } from "react";
import { COMMIT } from "../helpers/commit";

class FooterProps { }

class FooterState { }

class Footer extends Component<FooterProps, FooterState> {
  render() {
    return (
      <footer className="footer">
        <div className="container">
          <div className="has-text-centered">
            Copyright &copy; {new Date().getFullYear()} Hawk American Outdoors, Inc.
            <br/>
            Build {COMMIT}
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
